import moment from "moment";
import { COURSE_STATUS, DEFAULT_DATE_FORMAT } from "../constants";
import { isValidDate } from "src/utils/isValidDate";

/**
 * Add "month" to number or returns "Never expire" if validPeriod is 0
 * @param {number} validPeriod
 * @returns {string}
 */
export const formatValidPeriod = (validPeriod) => {
  return validPeriod === 0 ? COURSE_STATUS.NEVER_EXPIRE : `${validPeriod} month`;
};
/**
 * Add "month" to number
 * @param {number} bufferZone
 * @returns {string}
 */
export const formatBufferZone = (bufferZone) => {
  return `${bufferZone} month`;
};

export const formatDate = (date, format = DEFAULT_DATE_FORMAT) => {
  return moment(date).format(format);
};

// the way certificates show "valid" is "DD.MM.YYYY" and this way the sort don't work
export const parseDateString = (dateStr) => {
  if (isValidDate(dateStr)) dateStr = formatDate(dateStr);

  const dashFormat = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;

  if (dashFormat.test(dateStr)) {
    const [year, month, day] = dateStr.split("-").map(Number);

    return new Date(year, month - 1, day);
  } else {
    const [day, month, year] = dateStr.split(".").map(Number);
    return new Date(year, month - 1, day);
  }
};

// reformat name into: $last, $first
// with $last being the last space-separated part
export const formatLastFirstName = (name) => {
  const parts = name.split(" ");
  if (parts.length === 1) {
    return name;
  }
  return parts[parts.length - 1] + ", " + parts.slice(0, -1);
};

// first name with initial only
export const formatShortName = (name) => {
  const parts = name.split(" ");
  if (parts.length === 1) {
    return name;
  }
  return parts.slice(1).join(" ") + ", " + parts[0][0] + ".";
};

export const convertDateTime = (dateString) => {
  const date = new Date(dateString);
  date.setTime(date.getTime() + 3 * 60 * 60 * 1000);
  const formattedDate = date
    .toLocaleString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
    .replace(" ", " - ");
  return formattedDate;
};
